import * as Sentry from '@sentry/react';
import {RecommendedAccountsImport} from '../../shared/api/definitions/import';
import {useApiMutation} from '../../hooks/api/api';

export const useQueueCustomerAccountsImport = () => {
  return useApiMutation(RecommendedAccountsImport, {
    onError: (error) => {
      Sentry.captureException(error);
    },
  });
};
